import BoxKit from "@/shared/components/kit/box";
import CardKit from "@/shared/components/kit/card";
import SkeletonKit from "@/shared/components/kit/skeleton";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
/**
 * SkeletonCardNumber
 *
 * نمایش اسکلتون (Skeleton) کارت شماره کارت برای زمان بارگذاری اطلاعات.
 * شامل بخش عنوان و بدنه کارت با عناصر اسکلتونی برای شبیه‌سازی محتوا.
 *
 * @returns JSX.Element
 */

const SkeletonCardNumber = () => {
  return (
    <CardKit
      width={"100%"}
      height={411}
      title={
        <StackKit direction={"row"} justifyContent={"space-between"}>
          <StackKit direction={"row"} gap={2} alignItems={"center"}>
            <SkeletonKit sx={{ width: "30px", height: "30px" }} />{" "}
            <TypoGraphyKit>
              <SkeletonKit sx={{ width: "50px", height: "10px" }} />
            </TypoGraphyKit>
          </StackKit>
        </StackKit>
      }
      sx={{
        background:
          "linear-gradient(153.86deg, rgba(0, 0, 0, 0.4) -11.84%, rgba(37, 37, 37, 0.370427) 14.24%, rgba(78, 78, 78, 0.340413) 40.7%, rgba(0, 0, 0, 0.237218) 75.66%, rgba(0, 0, 0, 0.12) 106.2%)",
        backdropFilter: " blur(242.1999969482422px)",
      }}
    >
      <StackKit
        sx={{
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          height: "300px",
        }}
      >
        <StackKit
          sx={{ width: "80%", minHeight: "200px" }}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <SkeletonKit sx={{ height: "162px", width: "300px" }} />
        </StackKit>
        <StackKit
          sx={{ width: "100%" }}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <BoxKit
            sx={{
              width: "50%",
              background:
                "linear-gradient(153.86deg, rgba(0, 0, 0, 0.4) -11.84%, rgba(37, 37, 37, 0.370427) 14.24%, rgba(78, 78, 78, 0.340413) 40.7%, rgba(0, 0, 0, 0.237218) 75.66%, rgba(0, 0, 0, 0.12) 106.2%)",
              borderRadius: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "40px",
            }}
            gap={1}
          >
            <TypoGraphyKit variant="body1">
              <SkeletonKit />
            </TypoGraphyKit>
          </BoxKit>
        </StackKit>
      </StackKit>
    </CardKit>
  );
};

export default SkeletonCardNumber;
